<template>
  <section role="modal">
    <div
      class="modal fade"
      id="registrosModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="registrosModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="registrosModalLabel">
              Escolha seu registro
            </h4>
          </div>
          <div class="modal-body">
            <div class="row row-field" style="padding-bottom: 5px;">
              <div class="row row-field">
                <p>
                  Você possui mais de um registro. Sempre que quiser, você pode
                  trocar de usuário no menu à direita, em "Trocar Registro".
                </p>
                <p><strong>Qual registro deseja usar agora?</strong></p>
              </div>

              <div class="registros">
                <span>
                  <i class="fa fa-user-circle-o fa-2x" aria-hidden="true"></i>
                </span>

                <div class="form-group">
                  <select
                    class="form-control"
                    v-model="funcionario"
                    @change="trocaUsuario(funcionario)"
                  >
                    <option
                      v-for="autenticado in autenticados"
                      :key="autenticado.id"
                      :value="autenticado"
                    >
                      {{ 'Registro ' + autenticado.registroFormatado }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <botao
              tipo="button"
              estilo="cheio-verde"
              rotulo="Esse Registro"
              icone="ok-modal"
              dismiss="modal"
            ></botao>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Botao from '@/components/botao';

export default {
  name: 'registrosModal',

  data() {
    return {
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      funcionario: this.$store.state.funcionario,
    };
  },

  computed: {
    carregaAutenticados() {
      return this.$store.state.usuarioLogado.funcionarios;
    },
  },

  watch: {
    carregaAutenticados(novo, anterior) {
      this.autenticados = novo;
      this.funcionario = novo[0];
    },
  },

  methods: {
    trocaUsuario(funcionario) {
      this.$store.commit('setFuncionario', funcionario);
    },
  },

  components: {
    Botao,
  },
};
</script>

<style scoped>
.registros {
  display: flex;
  justify-content: center;
  color: #00615c;
  margin-top: 20px;
}
.registros span {
  display: flex;
  padding: 3px 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// registros-modal.vue?0bc20087